__turbopack_context__.v({
  "centerButtonText": "PlainTabControl-module__1x0nmG__centerButtonText",
  "reduceButtonSpacing": "PlainTabControl-module__1x0nmG__reduceButtonSpacing",
  "selected": "PlainTabControl-module__1x0nmG__selected",
  "tabBar": "PlainTabControl-module__1x0nmG__tabBar",
  "tabPageInner": "PlainTabControl-module__1x0nmG__tabPageInner",
});
